const it = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nome fonte di individuazione',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'ID utente',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL ServiceNow',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Password',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'URL non valido',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Frequenza di individuazione',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Richiedere agli utenti di rispondere alle domande di autenticazione basata sulla conoscenza (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Scopri le app e i carichi di lavoro tramite una di queste popolari fonti di individuazione. Potrai usufruire di vantaggi come dettagli precompilati, suggerimenti prioritari e una visualizzazione completa dello stato di integrazione.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Indietro',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Imposta individuazione',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'A breve...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Scopri di più',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    "Inserire le credenziali dell'applicazione per stabilire una connessione. Una volta stabilita la connessione, sarà possibile importare i dati.",
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Si è verificato un errore durante il caricamento della pagina.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    "Provare ad aggiornare o riprovare più tardi. Se il problema persiste, contattare l''amministratore.",
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Ricarica',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Impostazioni di connessione',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Classi CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Mapping di attributi',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Dettagli sulla connessione',
  'INTEGRATIONS.BUTTON.SAVE': 'Salva',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Seleziona',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Crea nuova connessione',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Usa questa connessione',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow salvato',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    "La connessione alla fonte di individuazione ServiceNow è stata testata e salvata correttamente. Importare i dati per finalizzare la configurazione dell''individuazione. Puoi saltare...",
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importa risorse',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Salta per ora',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    "Una volta avviata, l''importazione non può essere annullata",
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Guida',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Seleziona connessione esistente',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nome connessione',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Abbiamo rilevato {total, plural, one {una} other {#}} configurazione di connessione esistente:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Avvia importazione',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importazione dati da file Excel. Attendere...',
  'INTEGRATIONS.TRY.AGAIN': 'Riprova',
  'INTEGRATIONS.CLOSE': 'Chiudi',
  'INTEGRATIONS.ERROR.CONNECTION': 'Errore di connessione. Riprovare.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    "È possibile uscire dalla pagina durante l''attesa. Al termine del processo, verrà inviata una notifica.",
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importa fonte di individuazione',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importa la fonte di individuazione da un file',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Scarica file di esempio',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nome fonte di individuazione',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Inserisci il nome del file',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Inserire un nome valido. Sono consentiti solo lettere, numeri e simboli di selezione.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Caricamento in corso...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continua',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Ecco i primi 10 record del file XLSX caricato.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Intestazione obbligatoria mancante',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Errori di colonna rilevati',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    "Risolvere i problemi prima di procedere all''importazione dei dati.",
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': "Escludi dall''importazione",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    "Conferma di integrazione dell''applicazione",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Abbiamo identificato il tipo di applicazione. Confermare se questo è il tipo di applicazione corretto che si sta integrando.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Il tipo di applicazione che si sta integrando è {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'No, selezionare da un elenco di applicazioni',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    "Sì, sto effettuando l'integrazione",
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integrazioni',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Aggiungi integrazione',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Nessun risultato trovato per',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'No',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'Integrazioni trovate.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Nessuna integrazione nascosta trovata.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Applicazioni individuate',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Proprietario:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Ultima individuazione il',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Connessione non riuscita',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Gli utenti hanno accesso',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Fonte individuazione',
  'INTEGRATIONS.BUTTON.ENABLE': 'Abilita',
  'INTEGRATIONS.BUTTON.DISABLE': 'Disattiva',
  'INTEGRATIONS.ENABLING': 'Abilitazione',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Individuazione',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Carica di nuovo',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Integra',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Nascondi',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Mostra',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    "Schede di configurazione dell''individuazione",
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Ignorare le modifiche non salvate?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Sono presenti modifiche non salvate. Le modifiche andranno perse se si continua.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Ignora modifiche',
  'INTEGRATIONS.BUTTON.CANCEL': 'Annulla',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Salva errore',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Torna alla pagina precedente',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': "Icona dell''applicazione",
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Esegui manualmente',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Disattivazione non riuscita',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE':
    'Attivazione non riuscita',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Disattivazione riuscita.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Attivazione riuscita.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    "Al momento è in corso un''altra importazione.",
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Le risorse sono attualmente in fase di importazione da parte di un altro processo. Riprovare più tardi.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Importazione non riuscita',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importazione di risorse da ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    "È possibile uscire dalla pagina durante l''attesa. Al termine del processo, verrà inviata una notifica.",
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Aggiungere nuova riga di mapping di attributi',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Aggiungi attributo',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Vuoto)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Elimina questo mapping',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Campo ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Campo Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Cerca attributo ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Cerca attributo Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Personalizzato)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Salvataggio non riuscito',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Configurazione di pianificazione',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'alle {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Ripeti il',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Ripeti i giorni',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Ripeti ogni',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Inserisci intervallo',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Intervallo di ripetizione in numero di giorni, settimane o mesi',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Giorno',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Settimana/e',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Mese',
  'INTEGRATIONS.DAYS.SUN': 'Dom',
  'INTEGRATIONS.DAYS.MON': 'Lun',
  'INTEGRATIONS.DAYS.TUE': 'Mar',
  'INTEGRATIONS.DAYS.WED': 'Mer',
  'INTEGRATIONS.DAYS.THU': 'Gio',
  'INTEGRATIONS.DAYS.FRI': 'Ven',
  'INTEGRATIONS.DAYS.SAT': 'Sab',
  'INTEGRATIONS.BUTTON.DISABLING': 'Disattivazione',
  'INTEGRATIONS.BUTTON.SAVED': 'Salvato',
  'INTEGRATIONS.BUTTON.SAVING': 'Salvataggio',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Confermi di voler disattivare? ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    "Disattivando la fonte di individuazione, l''importazione delle risorse verrà interrotta e non sarà possibile configurare la fonte.",
  'INTEGRATIONS.DISCOVERY.HERE': 'qui',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    "La fonte individuazione è stata creata correttamente, ma la connessione a ServiceNow non è riuscita. Per avviare l''importazione delle risorse, aggiornare i dettagli della connessione nella pagina di configurazione della fonte individuazione ",
};

export default it;
